import availabilityIsAvailable from "../isAvailable";

/**
 * Détermine le plus grand jour de fin de séjour possible.
 * Renvoie le premier jour rencontré étant non disponible ou à défaut le jour maximum.
 * @param {object} param0.availabilities Les informations de l'API à propos des dates.
 */
export default function availabilityGetMaxCheckoutDateUntilNonAvailable({
  availabilities,
  start,
  to,
}) {
  const date = start.clone();

  while (date.isLessThan(to)) {
    if (
      !availabilityIsAvailable({
        availability: availabilities[date.format("Y-m-d")],
      })
    ) {
      // Si la jour n'est pas disponible, c'est le bon candidat pour le jour maximum.
      return date;
    }

    date.addDate(1);
  }

  return to;
}
